module.exports = __webpack_public_path__ + "89b0b1053c653aadfc30d200d00115ec.jpg";